import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.community');
import { OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-community',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.community/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageCommunityComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public category: string = '';
    public menu: string = '';
    public id: string = '';

    private routerSub: any;

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");

        this.updateSegments();
        await this.service.render();

        if (!WizRoute.segment.category)
            return this.service.href("/community/recent/list");
        else if (!WizRoute.segment.menu)
            return this.service.href(`/community/${WizRoute.segment.category}/list`);

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                if (!WizRoute.segment.category)
                    return this.service.href("/community/recent/list");
                else if (!WizRoute.segment.menu)
                    return this.service.href(`/community/${WizRoute.segment.category}/list`);

                let reload = (this.id != WizRoute.segment.id && WizRoute.segment.id);
                this.updateSegments();
                await this.service.render();
            }
        });
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    private updateSegments() {
        this.category = WizRoute.segment.category;
        this.menu = WizRoute.segment.menu;
        this.id = WizRoute.segment.id;
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0;
    }

    public activeClass(link: string) {
        if (this.isActive(link)) {
            return "group flex gap-x-3 rounded-md bg-zinc-50 py-2 pl-2 pr-3 text-sm font-semibold leading-6 text-blue-600";
        }
        return "group flex gap-x-3 rounded-md py-2 pl-2 pr-3 text-sm font-semibold leading-6 text-zinc-700 hover:bg-zinc-50 hover:text-blue-600";
    }
}

export default PageCommunityComponent;